export class Plan {
	public static parse(data: IPlan): Plan {
		const plan: Plan = new Plan();
		if (data.id !== undefined) {
			plan.id = data.id;
		}
		if (data.owner !== undefined) {
			plan.owner = data.owner;
		}
		if (data.title !== undefined) {
			plan.title = data.title;
		}
		if (data.createdDateTime !== undefined) {
			plan.createdDateTime = data.createdDateTime;
		}
		return plan;
	}

	// https://docs.microsoft.com/ja-jp/graph/api/resources/plannerplan?view=graph-rest-1.0
	public id: string = "";
	public owner: string = "";
	public title: string = "";
	public createdDateTime?: Date;
	public createdBy?: any;
}

export interface IPlan {
	id?: string;
	owner?: string;
	title?: string;
	createdDateTime?: Date;
}
